<template>
   
<header class="page-header" style="background: url('images/cont.jpg') center no-repeat;">
	<div class="container">
	<h1>Hi {{ name }}</h1>
	</div>
	</header>
</template>

<script>
export default {
  props:['name'],
    
}

</script>
<style></style>
